<template>
  <div>
    <div class="d-flex mb-2">
      <div>
        <span class="font-weight-bold">Conditions</span>
      </div>
      <div class="ml-auto" @click="addCondition">
        <u class="pointer text-blue">Add</u>
      </div>
    </div>
    <div v-for="(item, index) in response.content.Condition" v-bind:key="index">
      <div class="px-3 pt-3 button-box mb-2" v-if="index !== count-1">
        <div class="d-flex mb-2">
          <div class="font-weight-bold">
            Condition # {{ index + 1 }}
          </div>
          <div class="ml-auto" v-if="count > 2">
            <font-awesome-icon
              @click="deleteCondition(index)"
              icon="trash-alt"
              class="pointer text-danger"
            />
          </div>
        </div>
        <b-row>
          <b-col md="12">
            <InputSelectValueObj
              title="Condition"
              :name="`Condition${index}`"
              isRequired
              v-model="item.Variable"
              :options="variableList"
              valueField="id"
              textField="name"
              @onDataChange="(val) => onDataChangeVariable(val, item)"
              :isValidate="v.content.Condition.$each.$iter[index].VariableId.$error"
              :v="v.content.Condition.$each.$iter[index].VariableId"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <InputSelectValueObj
              title="Operation"
              :name="`Operation${index}`"
              isRequired
              v-model="item.Symbol"
              :options="item.Variable.type === 'String' ? symbolStringList : item.Variable.type === 'Number' ? symbolNumberList : symbolList"
              valueField="id"
              textField="name"
              @onDataChange="(val) => onDataChangeSymbol(val, item)"
              :isValidate="v.content.Condition.$each.$iter[index].SymbolId.$error"
              :v="v.content.Condition.$each.$iter[index].SymbolId"
            />
          </b-col>
          <b-col md="6" class="custom-div">
            <InputText
              v-model="item.Value"
              textFloat="Value"
              placeholder="Value"
              type="text"
              :name="`Value${index}`"
              :isRequired="item.Symbol.isRequired"
              :isValidate="v.content.Condition.$each.$iter[index].Value.$error"
              :v="v.content.Condition.$each.$iter[index].Value"
              :detail="`Type: ${item.Variable.type}`"
            />
          </b-col>
        </b-row>
        <b-row>
          <b-col md="12" class="intent-true">
            <InputSelect
              title="True"
              name="ReplyMainIntentIdTrue"
              isRequired
              v-model="item.ReplyMainIntentIdTrue"
              :options="allFirstFlowList"
              valueField="mainIntentId"
              textField="intentName"
              @onDataChange="val => item.ReplyMainIntentIdTrue = val"
              :isValidate="v.content.Condition.$each.$iter[index].ReplyMainIntentIdTrue.$error"
              :v="v.content.Condition.$each.$iter[index].ReplyMainIntentIdTrue"
            />
          </b-col>
        </b-row>
        <b-row v-if="index === count-2">
          <b-col md="12" class="intent-false">
            <InputSelect
              title="False"
              name="ReplyMainIntentIdFalse"
              isRequired
              v-model="response.content.Condition[count-1].ReplyMainIntentIdFalse"
              :options="allFirstFlowList"
              valueField="mainIntentId"
              textField="intentName"
              @onDataChange="val => response.content.Condition[count-1].ReplyMainIntentIdFalse = val"
              :isValidate="v.content.Condition.$each.$iter[count-1].ReplyMainIntentIdFalse.$error"
              :v="v.content.Condition.$each.$iter[count-1].ReplyMainIntentIdFalse"
            />
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import InputText from "@/components/inputs/InputText";
import InputSelect from "@/components/inputs/InputSelect";
import InputSelectValueObj from "@/components/inputs/InputSelectValueObj";

export default {
  components: {
    InputSelect,
    InputText,
    InputSelectValueObj
  },
  props: {
    response: {
      required: true,
      type: Object
    },
    v: {
      required: false,
      type: Object
    }
  },
  data() {
    return {
      value: 0,
    };
  },
  computed: {
    ...mapGetters({ allFirstFlowList: 'flowBuilder/getAllFirstFlowList' }),
    ...mapGetters({ symbolList: 'flowBuilder/getSymbolList' }),
    ...mapGetters({ symbolStringList: 'flowBuilder/getSymbolStringList' }),
    ...mapGetters({ symbolNumberList: 'flowBuilder/getSymbolNumberList' }),
    ...mapGetters({ variableList: 'flowBuilder/getVariableList' }),
    count() {
      return this.response.content.Condition.length 
    }
  },
  methods: {
    handleChangeVariable(value) {
      this.response.content.Condition.VariableId = value;
    },
    handleChangeTrue(value){
      this.response.content.Condition.ReplyMainIntentIdTrue = value;
    },
    handleChangeFalse(value){
      this.response.content.Condition.ReplyMainIntentIdFalse = value;
    },
    handleChangeSymbol(value){
      this.response.content.Condition.SymbolId = value;
    },
    addCondition(){
      this.response.content.Condition.splice(this.count-1, 0, 
        {
          VariableId: 0,
          Variable: this.variableList[0],
          SymbolId: 0,
          Symbol: this.symbolList[0],
          Value: "",
          ReplyMainIntentIdTrue: 0,
          ReplyMainIntentIdFalse: 0,
          ReplyType: this.response.content.ReplyType,
          IntentConditionIdTrue: 0,
          IntentConditionIdFalse: 0,
          IntentReplyId: 0,
          IsLast: false,
        }
      )
    },
    deleteCondition(index) {
      this.response.content.Condition.splice(index, 1);
    },
    onDataChangeSymbol(val, item) {
      item.SymbolId = val.id;
      item.Symbol = val;
    },
    onDataChangeVariable(val, item) {
      item.VariableId = val.id;
      item.Variable = val;
      this.onDataChangeSymbol(this.symbolList[0], item)
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .intent-true label {
  color: #2eb85c !important;
}
::v-deep .intent-false label {
  color: #e55353 !important;
}
.button-box {
  background-color: #cdcae2;
  border-radius: 6px;
}
::v-deep .custom-div .div-input {
  margin-bottom: 0px !important;
}
</style>
